import { NavLink, useLocation } from 'react-router-dom';
import { House, Drop, CreditCard, Car, ClockCounterClockwise, UserCircle, Wallet } from '@phosphor-icons/react';
import { useLanguage } from '../contexts/LanguageContext';
import { useAuth } from '../contexts/AuthContext';

export default function BottomNav() {
  const { t } = useLanguage();
  const { isAdmin } = useAuth();
  const location = useLocation();

  // Don't show on admin pages, owner console, VIP card, kiosk TV view, or auth pages
  if (location.pathname.startsWith('/admin') || location.pathname.startsWith('/owner-console') || location.pathname.startsWith('/kiosk') || location.pathname === '/login' || location.pathname === '/register') {
    return null;
  }

  const navItems = [
    { path: '/', icon: House, label: t('home') },
    { path: '/programs', icon: Drop, label: t('programs') },
    { path: '/subscriptions', icon: CreditCard, label: t('subscriptions') },
    { path: '/my-car', icon: Car, label: t('myCar') },
    { path: '/history', icon: ClockCounterClockwise, label: t('history') },
    { path: '/account', icon: UserCircle, label: t('account') },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 glass-panel border-t border-white/10" data-testid="bottom-nav">
      <div className="flex items-center justify-around px-1 py-2 max-w-lg mx-auto" style={{ paddingBottom: 'calc(6px + env(safe-area-inset-bottom, 0px))' }}>
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `flex flex-col items-center gap-0.5 px-2 py-1 rounded-xl transition-all duration-200 min-w-[50px] ${
                isActive
                  ? 'text-[#0ABAB5]'
                  : 'text-white/40 hover:text-white/60 active:text-white/80'
              }`
            }
            data-testid={`nav-${item.path.replace('/', '') || 'home'}`}
          >
            {({ isActive }) => (
              <>
                <item.icon 
                  size={22} 
                  weight={isActive ? 'fill' : 'regular'}
                  className="transition-transform duration-200"
                />
                <span className="text-[9px] font-medium tracking-tight leading-tight">{item.label}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
